import React, { MutableRefObject, memo, useCallback, useMemo, useRef } from 'react';
import { Carousel as AntdCarousel, CarouselProps } from 'antd';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import classNames from 'classnames';
import type { CarouselRef } from 'antd/lib/carousel';

import styles from './carousel.module.scss';

interface Props extends CarouselProps {
	containerClassName?: string;
	carouselRef?: MutableRefObject<CarouselRef>;
}

export const Carousel = memo((props: Props) => {
	const { className, carouselRef, containerClassName, arrows, ...otherProps } = props;
	const defRef = useRef();
	const ref = useMemo(() => carouselRef ?? defRef, [carouselRef, defRef]);

	const appendDots = useCallback(
		dots => (
			<div className={styles.customDotPosition}>
				<ul> {dots} </ul>
			</div>
		),
		[]
	);

	return (
		<div className={styles.carouselWrapper}>
			{/* empty div required here to avoid margins overlap */}
			<div>
				<AntdCarousel
					ref={ref}
					className={classNames(styles.bringgCarousel, className)}
					dotPosition="bottom"
					dots={{ className: styles.customDotPosition }}
					appendDots={appendDots}
					arrows={arrows}
					prevArrow={
						arrows ? (
							<span className={styles.arrowWrapper}>
								<BringgIcon iconName={BringgFontIcons.ChevronLeft} />
							</span>
						) : null
					}
					nextArrow={
						arrows ? (
							<span className={styles.arrowWrapper}>
								<BringgIcon iconName={BringgFontIcons.ChevronRight} />
							</span>
						) : null
					}
					{...otherProps}
				>
					{props.children}
				</AntdCarousel>
			</div>
		</div>
	);
});
